import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PublicThemeProvider, usePublicTheme } from "../../context/PublicThemeContext";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  const { light } = usePublicTheme();
  return (
    <div className={`min-h-screen flex flex-col bg-slate-50 ${light ? "public-light" : ""}`}>
      <ScrollTop />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default function Layout() {
  return (
    <PublicThemeProvider>
      <Shell />
    </PublicThemeProvider>
  );
}
